import { render, staticRenderFns } from "./projectKpBind.vue?vue&type=template&id=8ead37aa&scoped=true&"
import script from "./projectKpBind.vue?vue&type=script&lang=ts&"
export * from "./projectKpBind.vue?vue&type=script&lang=ts&"
import style0 from "./projectKpBind.vue?vue&type=style&index=0&id=8ead37aa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ead37aa",
  null
  
)

export default component.exports